import Controller from '@ember/controller';

export default class RoombaListController extends Controller {}
